import {simplify} from './cmp';

export function sanitizeFileName(fileName: string): string {
  const [name, extension] = fileName.includes('.')
    ? [fileName.slice(0, fileName.lastIndexOf('.')), fileName.slice(fileName.lastIndexOf('.') + 1)]
    : [fileName, ''];
  const sanitizedBaseName = simplify(name)
    .trim()
    .replace(/\s{2,}|\s/g, '-');
  return sanitizedBaseName + (extension ? '.' + extension.trim() : '');
}

export const UPLOAD_MAX_FILE_SIZE_BYTES = 20 * 1024 * 1024;

// The list should be in sync with the supported files in app/Formy/FormyFilePicker.tsx:22.
export const ALLOWED_ATTACHMENT_TYPES = [
  '.pdf',
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.csv',
  '.txt',
  '.rtf',
  '.xml',
  '.ppt',
  '.pptx',
  '.jpg',
  '.jpeg',
  '.png',
  '.bmp',
  '.webp',
  '.heif',
  '.heic',
  '.tif',
  '.tiff',
  '.mp3',
  '.wav',
  '.aac',
  '.m4a',
  '.ogg',
  '.mp4',
  '.mov',
  '.avi',
  '.mkv',
  '.wmv',
  '.zip',
  '.kml',
];
